/***
**Module Name: client
 **File Name :  client.js
 **Project :    Orasi Media
 **Copyright(c) : X Platform Consulting.
 **Organization : Peafowl Inc
 **author :  chandrasekhar
 **author :  Hari
 **license :
 **version :  1.0.0
 **Created on :
 **Created on: Dec 29 2022
 **Last modified on: Dec 29 2022
 **Description : contains clients table details.
 ***/
import React, { useState, useEffect, useContext } from "react";
import Footer from "../../components/dashboard/footer";
import Header from "../../components/dashboard/header";
import Sidebar from "../../components/dashboard/sidebar";
import tmdbApi from "../../api/tmdbApi";
import { useNavigate, Link, useLocation } from "react-router-dom";
import moment from "moment";
import axios from 'axios';
import Modal from 'react-bootstrap/Modal';
import TableLoader from "../../components/tableLoader";

import { contentContext } from "../../context/contentContext";
import * as Config from "../../constants/Config";
import SweetAlert from 'react-bootstrap-sweetalert';
import SessionPopup from "../SessionPopup"
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import Select from 'react-select';
let { lambda, country, appname } = window.app;


const Client = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { search } = state || {};
    // const [toggle, setToggle] = useState(false);
    const [content, setContent] = useState("");
    const [perpage, setPerpage] = useState(10);
    const [loaderEnable, setLoaderEnable] = useState(false);
    // const [data, setData] = useState([]);



    const [countries, setCountries] = useState('');
    const [itemsPerPage, setitemsPerPage] = useState(10);

    const [pageNumberLimit, setpageNumberLimit] = useState(5);
    const [maxPageNumberLimit, setmaxPageNumberLimit] = useState(5);
    const [minPageNumberLimit, setminPageNumberLimit] = useState(0);
    const [image, setImg] = useState('');
    const [flag, setFlag] = useState(false);
    // const [isLoading, setIsLoading] = useState(false);
    const [tableErrMsg, setTableErrMsg] = useState(false);
    const [companyData, setCompanyData] = useState({});
    const [popup, setShowPopup] = useState(false);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);

    const handleClosePopup = () => setShowPopup(false);
    const [arrowdir, setArrowDir] = useState('down');
    const [num, setNum] = useState();





    const { searchedFlag, setSearchedFlag, isLoading, setIsLoading, sortTableAlpha, arrow, sortTableByDate, userData, clientmanagesearch, setClientMangeSearch, clientAdvSearch, setClientAdvSearch, data, setData, rowsPerPage, setRowsPerPage, currentPageNew, setCurrentPage, route, setActiveMenuObj, activeMenuObj, processObject, setRoute, usePrevious, setActiveMenuId, GetTimeActivity } = useContext(contentContext)
    const validateObj = userData && userData.permissions && userData.permissions.length > 0 && userData.permissions.filter(eachItem => eachItem.menu == "Client Management")
    const subValDashboard = validateObj && validateObj[0] && validateObj[0].submenus && validateObj[0].submenus[0] && validateObj[0].submenus[0].dashboard
    const prevRoute = usePrevious(route)
    useEffect(() => {
        if (prevRoute != undefined && prevRoute != route) {
            setCurrentPage(1)
            setRowsPerPage(15)
            setClientAdvSearch({})
            setSearchedFlag(false);
            setClientMangeSearch("");
        }
    }, [prevRoute]);


    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imagesCDN) {
                    setImg(window.site.common.imagesCDN)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imagesCDN) {
            setImg(window.site.common.imagesCDN)
        }

    }, [window.site]);
    const getCountryCode = (idc) => {
        
        if (!countries || !Array.isArray(countries)) return "";

        const country = countries.find(
            item => item?.alpha3?.trim() === idc || item?.alpha3 === idc
        );

        return country
            ? country.countrycode.replace(/[()]/g, "")
            : "";
    };

    //  console.log('prevRoute--->',prevRoute)
    //  console.log('currentRoute--->',route)
    const keyForRerender = `${rowsPerPage}_${data?.length}`;
    const columns = [

        {
            name: 'Name',
            selector: row => row?.name ?? "",
            sortable: true,
        },
        {
            name: 'Type',
            selector: row => row?.type ?? "",
            sortable: true,
        },
        {
            name: 'Email',
            selector: row => row?.personalemail ?? "",
            sortable: true,
        },
        {
            name: 'Phone Number',
            selector: row =>
                `${getCountryCode(row?.idc)} ${row?.personalphone ?? ""}`,
            sortable: true,
        },
        {
            name: 'ACCOUNT MANAGER',
            // selector: row => row && row.companydetails && row.companydetails[0] && row.companydetails[0].accountmanager && row?.companydetails[0]?.accountmanager && row?.companydetails[0]?.accountmanager != undefined && row?.companydetails[0]?.accountmanager != "" ? row?.companydetails[0]?.accountmanager : "",
            selector: row => row?.companydetails?.[0]?.accountmanager ?? '',

            sortable: true,
        },
        {
            name: 'Entity',
            selector: row => row?.entity === "COMPANY"
                ? (
                    Array.isArray(row?.companyname)
                        ? (
                            typeof row.companyname[0] === "string"
                                ? row.companyname[0]
                                : row.companyname[0]?.name || ""
                        )
                        : row?.companyname || ""
                )
                : row?.entity,
            sortable: true,
        },

        {
            name: 'Status',
            selector: row => row?.status ?? "",
            sortable: true,
        },


        {
            name: 'Created by',
            selector: row => row.source, // optional if you don’t need dynamic value
            // cell: () => "ORGANIC", // static text
            sortable: true,
        },

        {
            name: 'Created on',
            selector: row => row?.created,
            sortable: true,
            cell: (props) => props?.created ? new Date(props?.created).toLocaleDateString('en-IN', {
                day: 'numeric',
                month: 'short',
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
            }) : "",
            // sortFunction: (a, b) => moment(a.created).diff(b.created),
        },

        {
            name: <>{(subValDashboard && subValDashboard.view && subValDashboard.view.display === true) || (subValDashboard && subValDashboard.edit && subValDashboard.edit.display === true) ? 'Actions' : null}</>,
            cell: (props) =>
                //  {
                //      subValDashboard && subValDashboard.view && subValDashboard.edit && (subValDashboard.view.display === true || subValDashboard.edit.display === true) &&
                <div className="d-flex">
                    {subValDashboard && subValDashboard.view && subValDashboard.view.display === true &&
                        <a onClick={e => handleViewClient(e, props.clientid)} className={`${subValDashboard && subValDashboard.view && subValDashboard.view.enable === false ? 'pe-none' : ''} text-success action-button`}><i className="mdi mdi-eye font-size-18"></i></a>}
                    {subValDashboard && subValDashboard.edit && subValDashboard.edit.display === true &&
                        <a onClick={e => handleEditClient(e, props.clientid)} className={`${subValDashboard && subValDashboard.edit && subValDashboard.edit.enable === false ? 'pe-none' : ''} text-danger action-button`}><i className="mdi mdi-pencil font-size-18"></i></a>}
                </div>
            //  }
            ,
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];


    const handlePageChange = (page) => {
        GetTimeActivity()
        setCurrentPage(page);
    };

    const handlePerRowsChange = (newPerPage) => {
        GetTimeActivity()
        setRowsPerPage(newPerPage);
    };

    const handleShowPopup = () => {
        GetTimeActivity()
        setShowPopup(true);
    };

    const handleClick = (event) => {
        GetTimeActivity()
        setCurrentPage(Number(event.target.id));
    };


    console.log('subValDashboard obj',subValDashboard)
    // const handleEditClient = (e,id) => {  
    //     navigate("/editclient/" + id);
    //  }

    const pages = [];
    for (let i = 1; i <= Math.ceil(content.totalClients / itemsPerPage); i++) {
        pages.push(i);
    }





    useEffect(() => {

        if (!localStorage.getItem("token")) {
            navigate("/");
        }
        setRoute("client")
        setActiveMenuId(300001)

        setActiveMenuObj({
            "Client Management": true,
            "Contact Management": false,
            "Reports": false
        })
        // if (search === true) {
        //     handleSearch();

        // } else {
        //     client();
        //     GetCountries();
        // }
        userActivity();
        GetCompany()
    }, []);


    // console.log('datataatatatta',data)

    const handleExport = () => {
        //    console.log('exportExcelData',global.exportExcelData)
        // let k = defaultData || exportExcelData
        const modifiedArray = global.exportExcelData.map((each, i) => ({
            "S.NO": i + 1,
            "NAME": each?.name ?? "",
            "TYPE": each?.type ?? "",
            "EMAIL": each?.personalemail ?? "",
            "COMPANY NAME": each?.companyname?.[0] ?? "",
            "PHONE NUMBER": each?.personalphone ?? "",
            "ACCOUNT MANAGER": each?.companydetails?.[0]?.accountmanager ?? "",
            "ENTITY": each?.entity === "COMPANY" ? (
                Array.isArray(each?.companyname)
                    ? (each.companyname?.[0] || each.companyname[0] || "")
                    : each?.companyname || ""
            )
                : each?.entity,

            "STATUS": each?.status ?? "",
            "Created By": each?.source ?? "",
            "CREATED ON": each?.created ? new Date(each?.created).toLocaleDateString('en-IN', {
                day: 'numeric',
                month: 'short',
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',

            }) : "",

        }));

        exportToExcel(modifiedArray, "data");

    }
    function exportToExcel(jsonData, fileName) {
        delete jsonData['_id'];
        const worksheet = XLSX.utils.json_to_sheet(jsonData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        //FileSaver.saveAs(data, `${fileName}.xlsx`);
        FileSaver.saveAs(data, `ClientsData.xlsx`);
    }
    const customSort = (rows, selector, direction) => {
        const sortedData = rows.slice().sort((rowA, rowB) => {
            // use the selector function to resolve your field names by passing the sort comparators

            const aField = String(selector(rowA)).toLowerCase();
            const bField = String(selector(rowB)).toLowerCase();

            let comparison = 0;

            if (aField > bField) {
                comparison = 1;
            } else if (aField < bField) {
                comparison = -1;
            }

            return direction === 'desc' ? comparison * -1 : comparison;
        });

        // setSortedData2(sortedData)
        global.exportExcelData = sortedData
        // console.log('Sorted Data------>:', sortedData);

        return sortedData;
    };
    const userActivity = () => {
        let path = window.location.pathname.split("/");
        const pageName = path[path.length - 1];
        var presentTime = moment();
        let payload;

        payload = {
            "userid": localStorage.getItem("userId"),
            "pagename": pageName,
            "pageurl": window.location.href,
            "starttime": presentTime,
            "useragent": JSON.parse(localStorage.getItem("loc"))

        };


        const previousId = localStorage.getItem("previousid");
        const urlLink = lambda + '/useractivity?appname=' + appname + (previousId ? "&previousid=" + previousId : "");


        axios({
            method: 'POST',
            url: urlLink,
            data: payload
        })
            .then(function (response) {
                if (response?.data?.statusCode === 200) {
                    localStorage.setItem("previousid", response?.data?.result)
                }
            });
    }
    useEffect(() => {


        console.log("trueeeeeeeeee", searchedFlag);
        if (searchedFlag) {
            console.log("came")
            handleSearch();
        } else {
            console.log("called get all deals")
            client();
            GetCountries();
        }

    }, [searchedFlag]);
    const GetCountries = async () => {
        setIsLoading(true);
        try {

            const response = await tmdbApi.getLookUp({
                "type": ["country"],
                "sortBy": "alpha3",
                "projection": "tiny"
            });


            setCountries(response?.result.data || []);



        } catch {
            console.log("error");
        }
    };
console.log("countries--->", countries);
    const client = (e) => {
        console.log('client call')
        GetTimeActivity()
        let page = 1;
        //  setCurrentPage(1);

        const token = localStorage.getItem("token")
        const userid = localStorage.getItem("userId")

        axios({
            method: 'POST',
            url: lambda + '/clients?appname=' + appname + "&token=" + token + "&userid=" + userid,
        })
            .then(function (response) {
                // console.log("response", response?.data?.result?.data);
                if (response?.data?.result == "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else {
                    setData(response?.data?.result?.data);
                    global.exportExcelData = response?.data?.result?.data


                    setContent(response?.data?.result);
                    setIsLoading(false);
                    setClientMangeSearch("");
                    setSearchedFlag(false);
                }

            }).catch((err) => {
                console.log('error', err);
                setTableErrMsg(true)
                setIsLoading(false);
            });
    }


    const handleChangeMultiSelect = (selected) => {
        GetTimeActivity();

        setClientAdvSearch({
            ...clientAdvSearch,
            companyname: selected?.value || ""   // store only value
        });
    };
    console.log("companyData--->", companyData);
    console.log('clientAdvSearch--->', clientAdvSearch)
    const handleAdd = () => {
        GetTimeActivity()
        navigate("/addclient")
    }
    const handleSearch = (e, flagggg) => {
        GetTimeActivity()
        setLoaderEnable(true)


        setFlag(true)
        if (flagggg === "normalsearch" || flagggg === "click") {
            setSearchedFlag(true)
        }

        if (clientmanagesearch === "" && clientAdvSearch.length <= 0) {
            client();
        }

        else {
            console.log('handle search')
            const token = localStorage.getItem("token")
            const userid = localStorage.getItem("userId")
            if (flagggg === "normalsearch") {
                setIsLoading(true)
            }
            let urlLink;

            urlLink = `${lambda}/clients?appname=${appname}&token=${token}&userid=${userid}${clientmanagesearch ? `&search=${clientmanagesearch}` : ''}`;

            // urlLink = lambda + '/clients?appname=' + appname + "&token=" + token + "&userid=" + userid

            // let payload = clientmanagesearch ? { search: clientmanagesearch, ...clientAdvSearch } : { ...clientAdvSearch };

            const result = processObject({ ...clientAdvSearch, companyname: clientAdvSearch?.companyname });
            setClientAdvSearch(result)
            axios({
                method: 'POST',
                url: urlLink,
                // data: payload,
                data: result,
            })
                .then(function (response) {
                    if (response?.data?.result == "Invalid token or Expired") {
                        setShowSessionPopupup(true)
                        setIsLoading(false)
                        setShowPopup(false)
                    } else {
                        // console.log("response", response);
                        setData(response?.data?.result?.data);
                        global.exportExcelData = response?.data?.result?.data
                        setContent(response?.data?.result);
                        setIsLoading(false);
                        setShowPopup(false)
                        setLoaderEnable(false);
                        if (flagggg === "click") {
                            setClientMangeSearch("")
                        }
                    }
                }).catch((err) => {
                    console.log('error', err);
                    setTableErrMsg(true)
                    setIsLoading(false);
                });
        }
    }

    const handleChange = (e) => {
        if (e.target.value === "") {
            //client();
            setFlag(false)
        }
        setClientMangeSearch(e.target.value)
    }

    const handleKeypress = (e) => {
        GetTimeActivity()
        //it triggers by pressing the enter key

        if ((e.key === "Enter")) {
            setTimeout(function () {
                handleSearch();
            }, 1000);
        }
    };
    const GetCompany = () => {
        GetTimeActivity()
        const token = localStorage.getItem("token")
        const userid = localStorage.getItem("userId")
        axios({
            method: 'post',
            url: lambda + '/companies?appname=' + appname + "&userid=" + userid + "&field=short",
        })
            .then(function (response) {
                if (response?.data?.result == "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else {
                    // console.log("response", response?.data?.result);
                    // setCompany(response?.data?.result?.data);

                    //  let arr = []

                    //  response?.data?.result?.data.forEach((item) => {
                    //    arr.push(item.companyname);


                    //  });

                    const arrOfObj = response?.data?.result?.data.map((item) => {
                        return { value: item.companyname, label: item.companyname };
                    });

                    setCompanyData(arrOfObj);

                }

            });
    }
    const handleEditClient = (e, paramuserid) => {
        console.log('paramuserid', paramuserid)
        GetTimeActivity()
        navigate("/editclient/" + paramuserid);
    }
    const handleViewClient = (e, paramuserid) => {
        GetTimeActivity()
        navigate("/viewclient/" + paramuserid);
    }

    const clearSearch = () => {
        GetTimeActivity()
        setClientMangeSearch("");
        setClientAdvSearch({})
        client();
    }

    const clearadvSearch = () => {
        GetTimeActivity()
        setClientAdvSearch({ ...clientAdvSearch, name: "", personalemail: "", idc: "+91", personalphone: "", type: "", entity: "", accountmanager: "", created: "", status: "", companyname: "" });
    }
    const handleAdvChange = (e) => {
        GetTimeActivity()
        setClientAdvSearch({ ...clientAdvSearch, [e.target.name]: e.target.value });
    }


    const customNoRecords = () => {
        return (

            <div className="empty-state-body empty-record"  >
                <div className="empty-state__message">
                    <span className="material-icons">summarize</span>
                    <p className="form-check font-size-16">No clients were found for the searched keyword</p>
                </div> </div>
        )
    }

    const companyList = Array.isArray(companyData) ? companyData : [];
    // console.log("current page", currentPageNew);
    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper">
                <Header />
                <Sidebar />

                <div className="main-content user-management clients">

                    <div className="page-content">
                        <div className="container-fluid">



                            <div className="row mb-4 breadcrumb">
                                <div className="col-lg-12">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h4 className="mb-2 card-title">CLIENT MANAGEMENT</h4>
                                            {/* <p className="menu-path">Client Management / <b>Clients</b></p> */}
                                        </div>
                                        {subValDashboard && subValDashboard.add && subValDashboard.add.display === true &&
                                            <div>
                                                <button onClick={handleAdd} className="btn btn-primary" disabled={subValDashboard && subValDashboard.add && subValDashboard.add.enable === false}>ADD CLIENT</button>
                                            </div>}
                                    </div>
                                </div>
                            </div>

                            <div className="row table-data">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row mb-2">
                                                <div className="col-sm-4 button-block">
                                                    <div className="dataTables_length" id="datatable_length">
                                                        <button className={`fill_btn ${data.length <= 0 ? 'disable pe-none' : ''}`} onClick={handleExport}><span className="material-icons">north_east</span>Export</button>
                                                    </div>
                                                </div>
                                                <div className="col-sm-8">
                                                    <div className="search-box mb-2 d-inline-block">

                                                        <div className="position-relative">
                                                            <input type="text" className="form-control" value={clientmanagesearch} onChange={(e) => handleChange(e)} onKeyPress={handleKeypress} placeholder="Search by Name or Email" />
                                                            <button className="fill_btn" onClick={(e) => handleSearch(e, "normalsearch")}><span className="material-icons search-icon" >search</span></button>
                                                        </div>
                                                        <div className="dataTables_length" id="datatable_length">
                                                            <button className="fill_btn" onClick={handleShowPopup}>Advanced Search</button>
                                                        </div>
                                                        <div className="dataTables_length" id="datatable_length">
                                                            <button className="fill_btn" onClick={clearSearch}><span className="material-icons-outlined">sync</span>Reset</button>
                                                        </div>


                                                    </div>
                                                    <div className="text-sm-end">

                                                    </div>
                                                </div>
                                            </div>


                                            < DataTable key={keyForRerender}
                                                // title=""
                                                columns={columns}
                                                // className="table align-middle table-nowrap table-check"
                                                keyField='_id'
                                                data={data}
                                                direction="auto"
                                                highlightOnHover
                                                fixedHeaderScrollHeight="300px"
                                                pagination
                                                responsive
                                                persistTableHead
                                                // selectableRowsVisibleOnly
                                                striped
                                                // selectableRowsHighlight
                                                // selectableRows
                                                subHeaderAlign="right"
                                                defaultSortField="name"
                                                subHeaderWra
                                                noDataComponent={customNoRecords()}
                                                paginationTotalRows={data.length}
                                                onChangeRowsPerPage={handlePerRowsChange}
                                                onChangePage={handlePageChange}
                                                paginationPerPage={rowsPerPage}
                                                paginationDefaultPage={currentPageNew}
                                                paginationRowsPerPageOptions={[15, 25, 50, 75, 100]}
                                                sortFunction={customSort}

                                                paginationComponentOptions={{
                                                    rowsPerPageText: 'Per page:',
                                                    rangeSeparatorText: 'of',
                                                    noRowsPerPage: false,
                                                    selectAllRowsItem: false,
                                                    selectAllRowsItemText: 'All',
                                                }}

                                                progressPending={isLoading}
                                                progressComponent={<TableLoader />}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>


                    <Modal className="advance-search search-popup" show={popup} onHide={handleClosePopup} backdrop="static">
                        <Modal.Header closeButton>
                            <Modal.Title>Advanced Search</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div>

                                <div className="row client-adv-search-form">
                                    <div className="col-md-6">
                                        <div className="input-field">
                                            <label className="col-form-label">NAME</label>
                                            <input className="form-control" placeholder="Enter Name" type="text" name="name"
                                                value={clientAdvSearch.name} onChange={(e) => handleAdvChange(e)}
                                                id="example-text-input" />

                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="input-field">
                                            <label className="col-form-label">EMAIL</label>
                                            <input className="form-control contact-number" name="personalemail" type="email" placeholder="Enter Email"
                                                value={clientAdvSearch.personalemail} onChange={(e) => handleAdvChange(e)}
                                                id="example-email-input" />



                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="input-field">
                                            <label className="col-form-label">Company Name</label>

                                            <Select
                                                isMulti={false}
                                                classNamePrefix="select category"
                                                placeholder="Company Name"
                                                name="companyname"
                                                onChange={handleChangeMultiSelect}
                                                options={companyList}
                                                value={
                                                    clientAdvSearch?.companyname
                                                        ? companyList.find(
                                                            (item) => item.value === clientAdvSearch.companyname
                                                        ) || null
                                                        : null
                                                }
                                            />




                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="input-field">
                                            <label className="col-form-label">Type</label>

                                            <select className="form-select" name="type"
                                                value={clientAdvSearch.type} onChange={(e) => handleAdvChange(e)}
                                            >
                                                <option value="">Select Type</option>
                                                <option>BUYER</option>
                                                <option>SELLER</option>
                                                <option>BOTH</option>
                                            </select>

                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="input-field">
                                            <label className="col-form-label">country code</label>
                                            <div className="country-code">
                                                <select name="idc" className="form-select colorselect capitalize"
                                                    value={clientAdvSearch.idc} onChange={(e) => handleAdvChange(e)}
                                                >
                                                    <option value="+91">INDIA(+91)</option>
                                                    {countries && countries?.length > 0 && countries?.map((task, i) => {
                                                        return (
                                                            <><option key={i} value={task.alpha3}>{task.name.toUpperCase() + task.countrycode}</option></>
                                                        )
                                                    }
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="input-field">
                                            <label className="col-form-label">contact number</label>
                                            <div className="country-code">

                                                <input className="form-control contact-number" type="tel" name="personalphone" placeholder="Enter Phone Number"
                                                    value={clientAdvSearch.personalphone} onChange={(e) => handleAdvChange(e)}
                                                    maxLength="10" id="example-tel-input" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="input-field">
                                            <label className="col-form-label">entity</label>

                                            <select className="form-select" name="entity"
                                                value={clientAdvSearch.entity} onChange={(e) => handleAdvChange(e)}
                                            >
                                                <option value="">Select Entity</option>
                                                <option>INDIVIDUAL</option>
                                                <option>COMPANY</option>

                                            </select>

                                        </div>
                                    </div>




                                    <div className="col-md-6">
                                        <div className="input-field">
                                            <label className="col-form-label">Account Manager</label>
                                            <input className="form-control" placeholder="Enter Name" type="text" name="accountmanager"
                                                value={clientAdvSearch.accountmanager} onChange={(e) => handleAdvChange(e)}
                                                id="example-text-input" />

                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="input-field">
                                            <label className="col-form-label">Created On</label>
                                            <input id="rights1" name="created" placeholder="dd-mm-yyyy" type="date" className="form-control" value={clientAdvSearch.created} onChange={(e) => handleAdvChange(e)} max={new Date().toISOString().split('T')[0]} />
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="input-field">
                                            <label className="col-form-label">Status</label>

                                            <select className="form-select" name="status"
                                                value={clientAdvSearch.status} onChange={(e) => handleAdvChange(e)}
                                            >
                                                <option value="">Select Status</option>
                                                <option value="PENDING APPROVAL">Pending Approval</option>
                                                <option value="PENDING VERIFICATION">Pending Verification</option>
                                                <option value="PENDING TERMS">Pending Terms</option>
                                                <option value="INACTIVE">Inactive</option>
                                                <option value="ACTIVE">Active</option>
                                                <option value="REJECT">Reject</option>
                                            </select>

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="adv_footer">

                                <button className="fill_btn yellow-gradient reset-btn" onClick={clearadvSearch}><span className="material-icons-outlined">sync</span>Reset</button>

                                <button onClick={(e) => handleSearch(e, "click")}
                                // className={`fill_btn yellow-gradient float-end ${Object.keys(searchPayload).length == 0 ? "disable" : ""}`} disabled={Object.keys(searchPayload).length == 0} 
                                >
                                    {loaderEnable ? (<img src={image + "orasi/client/resources/orasiv1/images/common-icons/rotate_right.svg"} className="loading-icon" />) : null}   SEARCH
                                </button>

                                <div className="clearfix"></div>
                            </div>
                        </Modal.Footer>
                    </Modal>
                    <SweetAlert show={tableErrMsg}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={"Something went wrong. Please reload again."}
                        onConfirm={e => setTableErrMsg(false)}
                    >
                    </SweetAlert>
                    <Footer />
                </div>

            </div>
        </>
    );
};

export default Client;
